module.exports = __webpack_public_path__ + "static/media/electricity.d4adc642.svg";